(() => {
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-popup-open]');
    const closeBtn = e.target.closest('[data-popup-close]');
    const wrapper = e.target.closest('[data-popup-wrapper]');

    if (!wrapper) return;

    const popup = wrapper.querySelector('[data-popup]');
    if (!popup) return;

    if (openBtn) popup.removeAttribute('hidden');
    if (closeBtn) popup.setAttribute('hidden', true);
    if (e.target.matches('[data-popup]')) popup.setAttribute('hidden', true);
  });
})();
